// removed by extract-text-webpack-plugin
module.exports = {"Container":"_OhR-f","Nav":"_flsq1","Image":"_3wTFE","MealsRight":"_3PJWg","MealsSelect":"_1gJ0t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Meals/Meals.scss
// module id = 570
// module chunks = 0